import ExamImage from "../components/ExamImage";
import { useRef, useState } from "react";
import QuestionLayout from "./QuestionLayout";

export default function LinearCircleFifthsWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const imgRef = useRef(null);
  const [imgSize, setImgSize] = useState(null);


  function normalizeCase(v) {
    if (!v) return v;

    if (config.case === "upper") return v.toUpperCase();
    if (config.case === "lower") return v.toLowerCase();

    return v; // default: no enforcement
  }

  function setAnswer(id, v) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      [id]: normalizeCase(v)
    });
  }

  // function setAnswer(id, v) {
  //   if (mode !== "edit") return;
  //   onChange({ ...value, [id]: v });
  // }

  function handleImageLoad(e) {
    setImgSize({
      w: e.target.naturalWidth,
      h: e.target.naturalHeight
    });
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div style={{ position: "relative", maxWidth: 640 }}>
        <ExamImage
          ref={imgRef}
          src={config.image}
          alt="Circle of Fifths"
          onLoad={handleImageLoad}
          style={{ width: "100%", height: "auto", display: "block" }}
        />

        {/* Only render overlays once image size is known */}
        {imgSize &&
          config.inputs.map(inp => {
            const part = feedback?.parts?.[inp.id];
            const isReview = mode === "review";

            return (
              <input
                key={inp.id}
                value={value[inp.id] || ""}
                disabled={mode !== "edit"}
                onChange={e => setAnswer(inp.id, e.target.value)}
                maxLength={2}
                style={{
                  position: "absolute",

                  /* 🔑 percentage positioning */
                  left: `${(inp.x / imgSize.w) * 100}%`,
                  top: `${(inp.y / imgSize.h) * 100}%`,

                  width: config.width ? config.width : 40,
                  height: config.height ? config.height : 40,
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                  fontSize: 18,
                  borderRadius: 4,

                  borderStyle: "solid",
                  borderWidth: isReview ? 2 : 1,
                  // borderColor: "blue",
                  borderColor: isReview
                    ? part?.correct
                      ? "#2e7d32"
                      : "#c62828"
                    : "#777",

                  // Keep the answer area visible without covering the
                  // printed flat/sharp symbols in the underlying image.
                  backgroundColor: isReview
                    ? part?.correct
                      ? "#e8f5e9"
                      : "#fdecea"
                    : "rgba(255, 255, 255, 0.38)",
                  boxSizing: "border-box"
                }}
              />
            );
          })}
      </div>
    </QuestionLayout>
  );
}
